export default __webpack_public_path__ + "static/maps-turkey-54447c88147c61b68279af00e745b0fa.png";